<template lang="pug">
.content-wrap
	.content-top
		.con
			.resbox-cusbox.dp.aaa
				.resbox-tabs
					ul.nav.nav-tabs.s2(role='tablist')
						li.nav-item.w-100(role='presentation' @click="changeTab(0)" :class="{'nav-active' : selectedTab === 0 }")
							button#member-profile.nav-link(:class="{'active' : selectedTab === 0}" )
								img(src='/new/img/af/m-profile.png')
								span {{$t('ui.profile')}}
						li.nav-item.w-100(role='presentation' @click="changeTab(3)" :class="{'nav-active' : selectedTab === 3 }")
							button#add-bank.nav-link(:class="{'active' : selectedTab === 3}" )
								img(src='/new/img/af/m-bank-a.png')
								span {{$t('ui.add_bank')}}
						li.nav-item.w-100(role='presentation' @click="changeTab(1)" :class="{'nav-active' : selectedTab === 1 }")
							button#member-bank.nav-link(:class="{'active' : selectedTab === 1}" ) 
								img(src='/new/img/af/m-bank-d.png')
								span {{$t('ui.bank_detail')}}
						li.nav-item.w-100(role='presentation' @click="changeTab(2)" :class="{'nav-active' : selectedTab === 2 }")
							button#member-cp.nav-link(:class="{'active' : selectedTab === 2}" ) 
								img(src='/new/img/af/m-password.png')
								span {{$t('ui.change_password')}}
					.tab-content
						userProfile(v-if="selectedTab === 0")
						bankProfile(v-if="selectedTab === 1" @switchTab="switchTab")
						changePw(v-if="selectedTab === 2")
						addBank(v-if="selectedTab === 3")
</template>
<script>
import userProfile from '@/component/_userProfile.vue'
import addBank from '@/component/bank/_addBank.vue'
import bankProfile from '@/component/_bankProfile.vue'
import changePw from '@/component/_changePw.vue'
export default {
	components:{
		userProfile,
		addBank,
		bankProfile,
		changePw
	},
	data(){
		return{
			selectedTab: 0,
		}		
	},
	computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    getDisplayName() {
      return this.$store.getters.username || this.$store.getters.accountID
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
  },
	watch:{
    sessionToken(newState, oldState){
      var vm = this
      if(newState === '' || newState === undefined){
        vm.$router.push("/").catch(err => {});
      }
    },
  },
	mounted(){
		window.scroll(0, 0)
		$('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/setting`);
		if(!_.isEmpty(this.$route.params)){
      if(this.$route.params.addBank == true){
				this.selectedTab = 1
			}
    }
	},
	methods:{
		changeTab(option){
			if(option === this.selectedTab){
				return;
			}else{
				this.selectedTab = option
			}
		},
		switchTab(e){
			this.selectedTab = e
		},
	},
}
</script>
<style lang="scss" scoped>
.nav-active{
	background-color: #280056;
	filter: grayscale(0);
}
</style>